
import React from 'react';
import './Article.css';


const Article4 = () => {
  return (
    <div className="article-container">
      <h2>2024/06/10   ベンジャミンさんの歓迎パーティーを行いました</h2>
      <p>カレーやチキンを食べました！！</p>
      <div className="article-images"> 
        <div className="article-image horizontal">
          <img src="/images/Article4_1.png" alt="Image 1" />
        </div>
      </div>
    </div>
  );
}


export default Article4;
